import Grid from '@mui/material/Grid';
import { OrderWithItems, Payment } from 'common-models';

import { FC, useEffect, useState } from "react";
import PageIsLoading from "src/components/PageIsLoading";
import { SwishPaymentInitiating } from "./SwishPaymentInitiating";
import { SwishPaymentOngoing } from "./SwishPaymentOngoing";


type SwishPaymentIndexViewProps = {
    order: OrderWithItems,
}

const SwishPaymentIndexView: FC<SwishPaymentIndexViewProps> = ({ order }) => {

    const [payment, setPayment] = useState(undefined as unknown as Payment);

    useEffect(() => {
        if (order?.payment !== undefined) {
            setPayment(order.payment)
        }
    }, [order])

    function getSwishPaymentComponent() {
        if (payment === undefined) {
            return <>(Ingen betalningsinfo hittades.)</>
        }

        switch (order.payment?.stateEvents[order.payment?.stateEvents.length - 1].state) {
            case 'Pending':
                return <SwishPaymentInitiating order={order} />

            case 'Ongoing':
                return <SwishPaymentOngoing order={order} />

            default:
                break;
        }
    }

    return (
        <>
            {
                order === undefined ? (
                    <PageIsLoading />
                ) : (

                    <Grid
                        container
                        className='cart-items-container'>
                        {getSwishPaymentComponent()}

                    </Grid>


                )
            }
        </>
    );
    // }
};

export { SwishPaymentIndexView };
